module.exports = __webpack_public_path__ + "static/media/MomentosBravectoCard5.ca09ee15.webp";